import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, SpaceBetween, Box } from '@awsui/components-react';

/**
 * Confirmation modal that appears when user selects different meetings while having chat history
 */
const ConfirmationModal = ({ visible, onDismiss, onProceed }) => {
  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header="Confirm Selection Change"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onProceed}>
              Proceed
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      Your chat history will be cleared. Do you want to proceed selecting a different set of meetings?
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
};

export default ConfirmationModal;
